import React from "react";

const BookMark = ({style = {}, size = "36", className = "", fill = "#73788B", viewBox = "0 0 36 36"}) => (
    <svg
        width={size}
        style={style}
        height={size}
        viewBox={viewBox}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={`${className || ""}`}
        xmlnsXlink="http://www.w3.org/1999/xlink"
    >
        <path className="u_fill"
            d="M7.556 2h21.777c.413 0 .809.163 1.1.454.292.29.456.685.456 1.096v29.674a.773.773 0 0 1-.8.776.78.78 0 0 1-.392-.119l-11.253-7.033L7.192 33.88A.78.78 0 0 1 6 33.224V3.55c0-.411.164-.805.456-1.096.291-.29.687-.454 1.1-.454Z"
            fill={fill}
        />
    </svg>
);

export default BookMark;
